// Copyright 2025, Imprivata, Inc.  All rights reserved.

import { Col, Row } from 'antd';
import { withRole } from '../../../common/authorization/Roles';
import { IntegrationToken, TokenType } from '../../../common/integration-token/IntegrationToken';
import { ROLE_TYPE_ADMIN } from '../../constants';
import './Integrations.less';

const VpamIntegration = () => {
  return (
    <div className="integrations-container">
      <Row>
        <Col sm={24} md={24} lg={24} className="setup-content p-xxxl">
          <IntegrationToken type={TokenType.VPAM} isSetup={false} />
        </Col>
      </Row>
    </div>
  );
};

export default withRole({ authorizedRoles: [ROLE_TYPE_ADMIN] })(VpamIntegration);
